import {useAllFieldsQuery} from '@transactions/graphql';
import {Plus} from 'lucide-react';
import * as React from 'react';
import {useBreadcrumb} from 'src/Breadcrumbs';
import {Button} from 'src/Button';
import {DashedAddButton} from 'src/DashedAddButton';
import {FieldCard} from 'src/FieldsView/FieldCard';
import {useModals} from 'src/Modals';

export const FieldsView = () => {
  useBreadcrumb({
    label: 'Fields',
    fallback: [{label: 'Settings', href: '/settings'}],
  });
  const {data, loading, refetch} = useAllFieldsQuery();
  const {createFieldModal} = useModals();

  const handleRefetch = () => {
    refetch();
  };

  const handleCreate = () => {
    createFieldModal.openModal({onSuccess: handleRefetch});
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <span className="text-muted-foreground">Loading fields...</span>
      </div>
    );
  }

  const fields = data?.allFields || [];

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold">Fields</h2>
          <p className="text-muted-foreground text-sm">
            Manage field attributes for your transactions
          </p>
        </div>
        <Button
          variant="primary"
          onClick={handleCreate}
          className="hidden sm:inline-flex"
        >
          <Plus className="mr-1 h-4 w-4" />
          Create Field
        </Button>
      </div>

      {fields.length === 0 ? (
        <div className="border-border rounded-lg border border-dashed p-8 text-center">
          <p className="text-muted-foreground mb-4">
            No fields created yet
          </p>
          <p className="text-muted-foreground mb-4 text-sm">
            Fields let you add structured attributes to transactions, like
            "fulfillment" (pickup, delivery, restaurant) or "recurring"
            (one-time, monthly).
          </p>
          <Button variant="outline" onClick={handleCreate} type="button">
            Create your first field
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          <DashedAddButton onClick={handleCreate}>Create Field</DashedAddButton>
          {fields.map((field) => (
            <FieldCard
              key={field._id}
              field={field}
              onUpdate={handleRefetch}
            />
          ))}
        </div>
      )}
    </div>
  );
};
